(function(){
if(window.__smLinkify)return;window.__smLinkify=true;
var MAP='https://www.google.com/maps/search/?api=1&query='+encodeURIComponent('Via Francesco Caracciolo 5, 04022 Fondi LT, Italia');
var RX=new RegExp([
 '(Via\\s+Francesco\\s+Caracciolo\\s*(?:n\\.?\\s*)?5(?:\\s*[,\\-\\u2013]\\s*(?:04022\\s*[,\\-]?\\s*)?Fondi(?:\\s*[,(]?\\s*(?:LT|Latina)\\)?)?(?:\\s*,?\\s*04022)?(?:\\s*,?\\s*(?:Italy|Italia))?)?)',
 '([A-Za-z0-9._%+\\-]+@[A-Za-z0-9\\-]+(?:\\.[A-Za-z0-9\\-]+)*\\.[A-Za-z]{2,})',
 '((?:\\+|00)39[\\s.\\-]?3\\d{2}[\\s.\\-]?\\d{3}[\\s.\\-]?\\d{3,4}|\\b3\\d{2}[\\s.\\-]?\\d{3}[\\s.\\-]?\\d{4}(?!\\d))'
].join('|'),'gi');
var SKIP={A:1,SCRIPT:1,STYLE:1,TEXTAREA:1,INPUT:1,BUTTON:1,SELECT:1,NOSCRIPT:1,OPTION:1,CODE:1,SVG:1,TITLE:1};
function skip(n){for(;n&&n!==document.body;n=n.parentNode){if(n.nodeType===1&&(SKIP[n.nodeName.toUpperCase()]||n.isContentEditable||(n.hasAttribute&&n.hasAttribute('data-nolink'))))return true;}return false;}
function conv(tn){
 var s=tn.nodeValue;if(!s||s.length<7)return;
 RX.lastIndex=0;if(!RX.test(s))return;RX.lastIndex=0;
 var f=document.createDocumentFragment(),last=0,m;
 while((m=RX.exec(s))){
  var t=m[0],a=document.createElement('a');
  if(m[1]){a.href=MAP;a.target='_blank';a.rel='noopener';}
  else if(m[2]){a.href='mailto:'+t;}
  else{var d=t.replace(/[^\d+]/g,'');if(d.indexOf('00')===0)d='+'+d.slice(2);if(d.charAt(0)!=='+')d='+39'+d;a.href='tel:'+d;}
  a.textContent=t;a.style.cssText='color:inherit;text-decoration:underline;text-underline-offset:2px';
  f.appendChild(document.createTextNode(s.slice(last,m.index)));f.appendChild(a);last=m.index+t.length;
 }
 f.appendChild(document.createTextNode(s.slice(last)));
 tn.parentNode.replaceChild(f,tn);
}
function run(root){
 var w=document.createTreeWalker(root||document.body,NodeFilter.SHOW_TEXT,null),list=[],n;
 while((n=w.nextNode())){if(!skip(n.parentNode))list.push(n);}
 list.forEach(conv);
}
var tm=0;
function later(){clearTimeout(tm);tm=setTimeout(function(){run()},250);}
function go(){run();if('MutationObserver' in window){new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){if(ms[i].addedNodes.length){later();return;}}}).observe(document.body,{childList:true,subtree:true});}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
